<template>
    <CRow>
        <CCol col>
            <ejs-grid ref='grid' :dataSource="userData" :allowFiltering='true' :allowPaging="true" :allowResizing='true'
                      :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                      :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar'
                      :pageSettings='pageSettings' :actionBegin='actionBegin' :actionComplete='actionComplete'
                      :actionFailure="actionFailure" :filterSettings='filterOptions'>
                <e-columns>
                    <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                    <e-column field='firstName' headerText='First Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='lastName' headerText='Last Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='email' headerText='Email' textAlign='Left' :validationRules='emailRules' width=90></e-column>
                    <e-column field='userGroupId' headerText='Role' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='roleParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='userGroups' width=90></e-column>
                    <!--<e-column field='clientId' headerText='Client' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='clientParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='clients' width=90></e-column>-->
                    <e-column field='clientIds' headerText='Clients' :visible='false' v-model="data.clientId" textAlign='Right' editType='dropdownedit' :edit='clientParams' :dataSource='clientsNew' width=90></e-column>
                    <e-column field='selectall' headerText='selectAll' textAlign='Right' displayAsCheckBox='true' :allowEditing="true" editType='booleanedit' width=90 :edit='checkboxParams' type='boolean' :visible='false'></e-column>

                </e-columns>
            </ejs-grid>
            <ejs-dialog ref="confirmDialog"
                        :visible="dialogVisible"
                        :width="'300px'"
                        :header="'Confirmation'"
                        :content="'Are you sure you want to resend the invite?'"
                        :showCloseIcon="true"
                        :buttons="dialogButtons"
                        :position="{ X: 'center', Y: 'top' }"
                        @close="closeDialog"
                        class="custom-dialog">
            </ejs-dialog>
        </CCol>
    </CRow>
</template>
<div id="mainSpinner"></div>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import apis from '../../../common/network';
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import { MultiSelectPlugin, MultiSelect } from "@syncfusion/ej2-vue-dropdowns";
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DialogPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let roleObj, roleElem, clientObj, clientElem, checkBoxObj, checkboxElem
    export default {
        name: 'UserForm',
        components: {

        },
        mounted() {
            const spinners = document.querySelectorAll(".e-grid .e-spinner-pane:not(#mainSpinner)");
            spinners.forEach(spinner => {

                spinner.style.display = 'none';

            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        data() {
            return {
                userGroups: SyncHelper.getDataManager('Utils/userGroups'),
                userData: SyncHelper.getDataManager("User"),
                clientInvoked: false,
                roleParams: {
                    create: () => {
                        roleElem = document.createElement('input');
                        return roleElem;
                    },
                    read: () => {
                        return roleObj.value;
                    },
                    destroy: () => {
                        roleObj.destroy();
                    },
                    write: (args) => {
                        roleObj = new DropDownList({
                            dataSource: this.userGroups,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'User Role',
                            floatLabelType: 'Always',
                            cssClass: 'required-input'
                        });
                        roleObj.appendTo(roleElem);
                    }
                },
                checkboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },
                    write: (args) => {
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            label: "Select all",
                            disabled: false,
                            change: (args) => {
                                if (args.checked == true) {
                                    this.clientInvoked = true;
                                    clientObj.selectAll(true);
                                }
                            }
                        });
                        if (args.rowData.selectAll === true)
                            this.clientInvoked = true;
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                clientParams: {
                    create: () => {
                        clientElem = document.createElement('input');
                        return clientElem;
                    },
                    read: () => {
                        return clientObj.value;
                    },
                    destroy: () => {
                        clientObj.destroy();
                    },
                    write: (args) => {
                        clientObj = new MultiSelect({
                            showSelectAll: true,
                            //selectAll: args.rowData.userGroupName == "System Administrator" || args.rowData.userGroupName == "Admin"? true : false,
                            dataSource: this.clientsNew,
                            fields: { text: 'name', value: 'id' },
                            value: args.rowData.clientIds,
                            placeholder: 'Clients',
                            floatLabelType: 'Always',
                            change: (args) => {
                                if (this.clientInvoked) {
                                    this.clientInvoked = false;
                                }
                                else {
                                    checkBoxObj.checked = false;
                                }
                            },
                            actionComplete: (args) => {
                                for (let item of args.result) {
                                    if (item.isParent) {
                                        item.name = `${item.name} (Client)`
                                    } else {
                                        item.name = `${item.name} (Company)`
                                    }
                                }
                            },
                        });
                        clientObj.appendTo(clientElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: this.$store.state.permissions["Permissions.Users.Update"],
                    allowAdding: this.$store.state.permissions["Permissions.Users.Create"],
                    allowDeleting: this.$store.state.permissions["Permissions.Users.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport', { text: 'Resend Invite', tooltipText: 'Invite will be resent', prefixIcon: 'e-icons e-refresh', id: 'ResendInvite' }],
                dialogVisible: false,
                selectedRowData: null,
                dialogButtons: [
                    { click: () => this.confirmAction(), buttonModel: { content: 'Yes', isPrimary: false } },
                    { click: () => this.closeDialog(), buttonModel: { content: 'No', isPrimary: true } },
                ],
                requiredRules: { required: true },
                emailRules: { email: true, required: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        methods: {
            toolbarClick(args) {
                console.log(args);
                gridOptions.excelExport(args, "Users.xlsx", this.$refs);
                if (args.item.id === 'ResendInvite') {
                    const selectedRecords = this.$refs.grid.getSelectedRecords();
                    if (selectedRecords.length > 0) {
                        this.selectedRowData = selectedRecords[0];
                        this.dialogVisible = true;
                    } else {
                        gridOptions.infoAlert('No row is selected.');
                    }
                }
            },
            confirmAction() {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi.post(`User/ResendInvite?id=${this.selectedRowData.id}`).then(it => {
                    hideSpinner(document.getElementById('mainSpinner'));
                    gridOptions.infoAlert(it.data.message);
                }
                ).catch(
                    response => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        gridOptions.errorAlert("Error Occurred!");
                    }
                );
                this.closeDialog();
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                this.$refs.grid.getColumns()[0].visible = false;
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    args.rowData.returnUrl = window.location.origin;
                    hideSpinner(document.getElementById('mainSpinner'));
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "email") {
                            this.$refs.grid.getColumns()[i].allowEditing = false;
                        }
                        if (this.$refs.grid.getColumns()[i].field == "clientIds") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                        if (this.$refs.grid.getColumns()[i].field == "selectall") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }
                }
                if (args.requestType === 'delete') {
                    if (args.data[0].email === this.$store.state.loggedInUserEmail) {
                        gridOptions.infoAlert(`User with email address ${args.data[0].email} is currently logged in and can not be removed.`);
                        args.cancel = true;
                        return;
                    }
                    if (args.data[0].userGroupName === "System Administrator") {
                        gridOptions.infoAlert(`System Administrator User cannot be edited nor deleted`);
                        args.cancel = true;
                        return;
                    }
                    if (args.data[0].userGroupName === "MyAlfe") {
                        gridOptions.infoAlert(`MyAlfe User cannot be edited nor deleted`);
                        args.cancel = true;
                        return;
                    }
                }
                if (args.requestType === 'beginEdit') {
                    //if (args.rowData.userGroupName === "System Administrator") {
                    //    gridOptions.infoAlert(`System Administrator User cannot be edited nor deleted`);
                    //    args.cancel = true;
                    //    return;
                    //}
                    if (args.rowData.userGroupName === "MyAlfe") {
                        gridOptions.infoAlert(`MyAlfe User cannot be edited nor deleted`);
                        args.cancel = true;
                        return;
                    }
                }
                if ((args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "email") {
                            this.$refs.grid.getColumns()[i].allowEditing = true;
                        }
                    }
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                    if (this.$refs.grid.getColumns()[i].field == "selectall") {
                        this.$refs.grid.getColumns()[i].visible = false;
                    }
                    if (this.$refs.grid.getColumns()[i].field == "clientIds") {
                        this.$refs.grid.getColumns()[i].visible = false;
                    }

                    if (args.requestType === 'beginEdit') {
                        if (args.rowData.selectAll == true) {
                            document.getElementsByName('selectall')[0].ej2_instances[0].checked = true;
                        }
                    }
                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["firstName", "lastName", "email"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));

            },
            onUploadSuccess: function (args) {
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            }

        },
        created: function () {
            this.$store.commit('setGroupUserTabLast', false);
        },
        computed: {
            clientsNew() {
                return SyncHelper.getDataManager(`utils/clients`)
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
    .custom-dialog {
        top: 250px !important;
        position: absolute !important;
    }

    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }

    [id$="clientIds"]::after {
        content: '' !important;
    }
</style>
